import { VertiIntegrationFlow } from '@global/enums';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './general.actions';
import { GenesysChat } from '@core/models/configurator';

export interface State {
  policyHolderAddressCheckbox: boolean | null;
  partnershipId: string | null;
  userId: string | null;
  projectId: string | null;
  policyId: string | null;
  policyVersion: string | null;
  sessionId: string | null;
  tkJwt: string | null;
  rtkJwt: string | null;
  gwCookie: string | null;
  noneUserParticipant: boolean | null;
  isPolicyFormPolicyNumber: boolean | null;
  isMortgageBankData: boolean | null;
  privacyPolicyInd: boolean | null;
  marketingResearchInd: boolean | null;
  commercialCommInd: boolean | null;
  businessResearchInd: boolean | null;
  profilingInd: boolean | null;
  partnershipIntegrationInd: boolean | null;
  userFlow: VertiIntegrationFlow | null;
  isBackOfficeUser: boolean | null;
  genesysChatInfo: GenesysChat | null;
  genesysChatVisibilityInd: boolean | null;
}

export const featureKey = 'flowDataGeneral';

export const initialState: State = {
  policyHolderAddressCheckbox: null,
  partnershipId: null,
  userId: null,
  projectId: null,
  policyId: null,
  policyVersion: null,
  sessionId: null,
  tkJwt: null,
  rtkJwt: null,
  gwCookie: null,
  noneUserParticipant: null,
  isPolicyFormPolicyNumber: null,
  isMortgageBankData: null,
  privacyPolicyInd: null,
  marketingResearchInd: null,
  commercialCommInd: null,
  businessResearchInd: null,
  profilingInd: null,
  partnershipIntegrationInd: null,
  userFlow: null,
  isBackOfficeUser: null,
  genesysChatInfo: null,
  genesysChatVisibilityInd: null,
};

export function generalReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.EmptyFlowDataGeneral, state => ({
      ...state,
      policyCheckbox: null,
      policyHolderAddressCheckbox: null,
      noneUserParticipant: null,
      isPolicyFormPolicyNumber: null,
      isMortgageBankData: null,
      privacyPolicyInd: null,
      marketingResearchInd: null,
      commercialCommInd: null,
      businessResearchInd: null,
      profilingInd: null,
      isBackOfficeUser: null,
      genesysChatInfo: null,
      genesysChatVisibilityInd: null,
    })),
    on(Actions.UpdatePolicyHolderAddressCheckbox, (state, { data }) => ({
      ...state,
      policyHolderAddressCheckbox: data,
    })),
    on(Actions.UpdatePartnershipId, (state, { data }) => ({
      ...state,
      partnershipId: data,
    })),
    on(Actions.UpdateUserId, (state, { data }) => ({
      ...state,
      userId: data,
    })),
    on(Actions.UpdateProjectId, (state, { data }) => ({
      ...state,
      projectId: data,
    })),
    on(Actions.UpdatePolicyId, (state, { data }) => ({
      ...state,
      policyId: data,
    })),
    on(Actions.UpdatePolicyVersion, (state, { data }) => ({
      ...state,
      policyVersion: data,
    })),
    on(Actions.UpdateSessionId, (state, { data }) => ({
      ...state,
      sessionId: data,
    })),
    on(Actions.UpdateTkJwt, (state, { data }) => ({
      ...state,
      tkJwt: data,
    })),
    on(Actions.UpdateRtkJwt, (state, { data }) => ({
      ...state,
      rtkJwt: data,
    })),
    on(Actions.UpdateGWCookie, (state, { data }) => ({
      ...state,
      gwCookie: data,
    })),
    on(Actions.NoneUserParticipants, (state, { data }) => ({
      ...state,
      noneUserParticipant: data,
    })),
    on(Actions.IsPolicyFormPolicyNumber, (state, { data }) => ({
      ...state,
      isPolicyFormPolicyNumber: data,
    })),
    on(Actions.IsMortgageBankData, (state, { data }) => ({
      ...state,
      isMortgageBankData: data,
    })),
    on(Actions.PrivacyPolicyInd, (state, { data }) => ({
      ...state,
      privacyPolicyInd: data,
    })),
    on(Actions.MarketingResearchInd, (state, { data }) => ({
      ...state,
      marketingResearchInd: data,
    })),
    on(Actions.CommercialCommInd, (state, { data }) => ({
      ...state,
      commercialCommInd: data,
    })),
    on(Actions.PartnershipIntegrationInd, (state, { data }) => ({
      ...state,
      partnershipIntegrationInd: data,
    })),
    on(Actions.UserFlow, (state, { data }) => ({
      ...state,
      userFlow: data,
    })),
    on(Actions.IsBackOfficeUser, (state, { data }) => ({
      ...state,
      isBackOfficeUser: data,
    })),
    on(Actions.BusinessResearchInd, (state, { data }) => ({
      ...state,
      businessResearchInd: data,
    })),
    on(Actions.ProfilingInd, (state, { data }) => ({
      ...state,
      profilingInd: data,
    })),
    on(Actions.GenesysChatInfoData, (state, { data }) => ({
      ...state,
      genesysChatInfo: data,
    })),
    on(Actions.GenesysChatVisibilityInd, (state, { data }) => ({
      ...state,
      genesysChatVisibilityInd: data,
    }))
  )(state, action);
}
